import { getStore as composeStore } from 'owa-mail-compose-store';
import { lazyDiscardCompose, lazyLoadDraftToCompose } from 'owa-mail-compose-actions';
import { lazyNewMessage } from 'owa-mail-message-actions';
import selectFolderWithFallback from './selectFolderWithFallback';
import getSelectedFolderMailboxInfoOrDefault from 'owa-mail-store/lib/utils/getSelectedFolderMailboxInfoOrDefault';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { getQueryStringParametersFromURL } from 'owa-content-handler/lib/utils/queryStringHelper';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { lazyBizChatHandleoff } from 'owa-bizchat-context-handlers';

export interface MailFolderRouteParameters {
    folderId?: string;
    draftId?: string;
}

export async function mailComposeNavigationRouteHandler(
    parameters: MailFolderRouteParameters
): Promise<void> {
    selectFolderWithFallback(parameters.folderId);

    if (parameters.draftId) {
        const convertedId = convertRestIdToEwsId(parameters.draftId); // If already in correct format, this should return the same id
        await lazyLoadDraftToCompose.importAndExecute(
            {
                Id: convertedId ? convertedId : parameters.draftId,
                mailboxInfo: getSelectedFolderMailboxInfoOrDefault(),
            },
            null /* sxsId */,
            'Route' /* actionSource */
        );
    } else {
        await lazyNewMessage.importAndExecute('Route');
    }
}

export function mailComposeCleanupRouteHandler(): Promise<boolean> | boolean {
    const primaryComposeId = composeStore().primaryComposeId;
    if (primaryComposeId) {
        const viewState = composeStore().viewStates.get(primaryComposeId);
        if (viewState) {
            return lazyDiscardCompose.importAndExecute(viewState).then(
                () => false, // Confirm ('Discard draft') means we should not block navigation
                () => true
            ); // Cancel ('Dont' discard') means we should block navigation
        }
    }
    return false;
}

const ApplinkActionSource = 'ApplinkRoute';

export async function mailComposeBizChatRouteHandler(): Promise<void> {
    const mailboxInfo = getSelectedFolderMailboxInfoOrDefault();

    if (isAccountFeatureEnabled('cmp-copilot-bizchat', mailboxInfo)) {
        const eventTimestamp = Date.now();
        const { h, h_env, refId, action } = getQueryStringParametersFromURL();
        const bizChatHandoff = await lazyBizChatHandleoff.import();

        bizChatHandoff(
            mailboxInfo,
            ApplinkActionSource /* source */,
            eventTimestamp /* eventTimestamp */,
            {
                handoffId: h,
                handoffEnv: h_env,
                refId,
                action,
            }
        );
    }
}
